import { createStore } from 'vuex'
import advanceInterview from '@/store/advanceInterview'
import medicalRecord from '@/store/medicalRecord'
import apiParams from '@/store/apiParams'
import medicalRecords from '@/store/medicalRecords';
import covidCertificate from '@/store/covidCertificate';
import requestError from './requestError';

export const store = createStore({
  modules: {
    advanceInterview,
    medicalRecord,
    apiParams,
    medicalRecords,
    covidCertificate,
    requestError
  }
})
